import config, { AppMode } from '@config';

export default function fbTrack(event: string, options: Record<string, any> = {}) {
  if (config.mode === AppMode.Production && typeof fbq === 'function') {
    fbq('track', event, options);
  }
}
